import { render, staticRenderFns } from "./customdrawer.vue?vue&type=template&id=354c1ab2&scoped=true&"
import script from "./customdrawer.vue?vue&type=script&lang=js&"
export * from "./customdrawer.vue?vue&type=script&lang=js&"
import style0 from "./customdrawer.vue?vue&type=style&index=0&id=354c1ab2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354c1ab2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-sub-design\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('354c1ab2')) {
      api.createRecord('354c1ab2', component.options)
    } else {
      api.reload('354c1ab2', component.options)
    }
    module.hot.accept("./customdrawer.vue?vue&type=template&id=354c1ab2&scoped=true&", function () {
      api.rerender('354c1ab2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customdrawer.vue"
export default component.exports